import { useEffect, useRef } from "react";

interface ToolTipProps {
    content:string,
    title:string,
    id:string,
    trigger?: string,
    placement?: string
}

const ToolTip = ({content, title, id, trigger = 'hover focus', placement = 'top'}:ToolTipProps) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        if(buttonRef.current && (window as any).bootstrap) {
            const Popover = (window as any).bootstrap.Popover;
            new Popover(buttonRef.current, {
                title,
                content,
                trigger,
                placement,
                html: true
            })
        }
    }, [title, content, trigger, placement]);

    return (
        <button type="button" className="btn btn-sm ms-auto p-2" ref={buttonRef} data-bs-toggle="popover" data-bs-title={title} data-bs-html="true" id={id}>
            <i className="bi bi-question-circle-fill"></i>
        </button>
    );
}

export default ToolTip;